export const PageHeader = ({ kicker, title, children }) => (
  <div className="rise mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-sky-400">{kicker}</div>
      <h1 className="font-display mt-1 text-4xl font-bold uppercase tracking-tight sm:text-5xl">{title}</h1>
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const KpiCard = ({ label, value, sub, tone = "default", testId, delay = 0 }) => {
  const tones = {
    default: "text-slate-100",
    amber: "text-amber-400",
    red: "text-red-400",
    green: "text-emerald-400",
    sky: "text-sky-300",
  };
  return (
    <div
      className="rise rounded-lg border border-slate-800 bg-[#131b29]/80 p-5 shadow-lg shadow-black/30"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="font-mono text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div data-testid={testId} className={`num mt-2 text-2xl font-semibold ${tones[tone]}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </div>
  );
};

export const Loading = () => (
  <div data-testid="loading" className="py-24 font-mono text-sm text-slate-500">Loading stock data…</div>
);
